import { RpcInterceptor } from "@protobuf-ts/runtime-rpc";

import { transport } from "../../../api/grpc/grpcTransport";
import { CheckoutItem } from "../../../api/grpc/subscription/subscription";
import { ChargeBeeHostedServiceClient } from "../../../api/grpc/subscription/subscription.client";

/**
 * Creates a Chargebee hosted checkout that adds add-ons, such as Total Care
 * Support, to the customer's existing subscription. Errors are thrown so the
 * caller can show them.
 */
export const createSubscriptionCheckout = async (
  customerID: string,
  subscriptionID: string,
  interceptor: RpcInterceptor,
  items: CheckoutItem[]
) => {
  const hostedServiceClient = new ChargeBeeHostedServiceClient(transport);

  const { response } = await hostedServiceClient.createSubscriptionCheckout(
    { customerID, subscriptionID, items },
    { interceptors: [interceptor] }
  );

  return response;
};
